"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../../../common/Icon"));

var _connectToMedia = _interopRequireDefault(require("../../Media/connectToMedia"));

var _components = _interopRequireDefault(require("../../../styles/components"));

var _ToolTip = _interopRequireDefault(require("../../../common/ToolTip"));

var _Smiley = _interopRequireDefault(require("../../../assets/icons/Smiley.svg"));

var _SmileyMeh = _interopRequireDefault(require("../../../assets/icons/SmileyMeh.svg"));

var _SmileySad = _interopRequireDefault(require("../../../assets/icons/SmileySad.svg"));

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    duration: state.media.duration
  };
};

function getColorBySentimentValue(value) {
  if (value >= 0.1) {
    return "#4B9368";
  }

  if (value >= 0.07 && value < 0.1) {
    return "#5EB480";
  }

  if (value >= 0.03 && value < 0.07) {
    return "#7CC77F";
  }

  if (value >= 0.01 && value < 0.03) {
    return "#A6CB62";
  }

  if (value >= 0 && value < 0.01) {
    return "#D6D94B";
  }

  if (value >= -0.01 && value < 0) {
    return "#E1B239";
  }

  if (value >= -0.02 && value < -0.01) {
    return "#F19A32";
  }

  if (value >= -0.04 && value < -0.02) {
    return "#F0812C";
  }

  if (value >= -0.06 && value < -0.04) {
    return "#F0632A";
  }

  if (value >= -0.08 && value < -0.06) {
    return "#EA4627";
  }

  if (value <= -0.08) {
    return "#B3361E";
  }

  return "#E1B239";
}

function setSentimentTooltip(title, sentiment, sentimentValue, sentimentIcon) {
  return /*#__PURE__*/_react["default"].createElement(_components["default"].GridRow, null, /*#__PURE__*/_react["default"].createElement(_components["default"].GridCell, null, /*#__PURE__*/_react["default"].createElement(_components["default"].ControlsGroup, null, /*#__PURE__*/_react["default"].createElement("img", {
    height: "50",
    alt: "Sentiment smiley",
    src: sentimentIcon
  })), /*#__PURE__*/_react["default"].createElement(_components["default"].TooltipContent, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      opacity: "50%",
      paddingTop: "7px"
    }
  }, title), /*#__PURE__*/_react["default"].createElement("div", null, sentiment, " ", /*#__PURE__*/_react["default"].createElement("span", null, "(" + Math.round(sentimentValue * 100) / 100 + ")")))));
}

var RegionTrack = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(RegionTrack, _React$Component);

  function RegionTrack() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = RegionTrack.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var _this = this;

    var list = ["label", "height", "regions", "duration", "color"];
    return !list.every(function (key) {
      return _this.props[key] === nextProps[key];
    });
  };

  _proto.getTooltipBySentimentValue = function getTooltipBySentimentValue(value) {
    var title = this.props.title;
    var tooltipTitle = (0, _lodash.upperCase)(title) + " SENTIMENT";

    if (value > 0.05) {
      return setSentimentTooltip(tooltipTitle, "Positive", value, _Smiley["default"]);
    }

    if (value < 0) {
      return setSentimentTooltip(tooltipTitle, "Negative", value, _SmileySad["default"]);
    }

    return setSentimentTooltip(tooltipTitle, "Neutral", value, _SmileyMeh["default"]);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        title = _this$props.title,
        icon = _this$props.icon,
        height = _this$props.height,
        regions = _this$props.regions,
        duration = _this$props.duration,
        color = _this$props.color,
        isSentimentAnalyzerOn = _this$props.isSentimentAnalyzerOn,
        transcriptLength = _this$props.transcriptLength,
        isChatTextMedia = _this$props.isChatTextMedia,
        turns = _this$props.turns,
        messagesDuration = _this$props.messagesDuration,
        _this$props$isDetecto = _this$props.isDetectorTrack,
        isDetectorTrack = _this$props$isDetecto === void 0 ? false : _this$props$isDetecto;
    var mediaDuration = isChatTextMedia ? messagesDuration > 1000 ? messagesDuration + 1000 : messagesDuration : duration || transcriptLength;

    if (mediaDuration) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_components["default"].Track, null, /*#__PURE__*/_react["default"].createElement(_components["default"].TrackLabel, {
        title: title
      }, title)), /*#__PURE__*/_react["default"].createElement(_components["default"].Track, null, /*#__PURE__*/_react["default"].createElement(_components["default"].TrackContent, null, /*#__PURE__*/_react["default"].createElement("svg", {
        width: "100%",
        height: height,
        shapeRendering: "crispEdges",
        viewBox: "0 0 100 10",
        preserveAspectRatio: "none",
        style: {
          display: "block"
        }
      }, regions.map(function (region, i) {
        var width = (region.end - region.start) / mediaDuration * 100;

        if (region.end === region.start) {
          if (isDetectorTrack) {
            width = 500 / mediaDuration * 100;
          } else if (isChatTextMedia) {
            var sentimentIndex = turns === null || turns === void 0 ? void 0 : turns.findIndex(function (turn) {
              return (0, _lodash.isEqual)(turn, region);
            });
            var timeDiff = turns[sentimentIndex + 1] ? turns[sentimentIndex + 1].start - region.start : region.start;
            width = timeDiff / mediaDuration * 100;
          }
        }

        return /*#__PURE__*/_react["default"].createElement(_ToolTip["default"], {
          key: region.start + "-" + region.end + "-" + i,
          placement: "bottom",
          trigger: ["hover"],
          overlayStyle: !isSentimentAnalyzerOn && {
            display: "none"
          },
          overlay: /*#__PURE__*/_react["default"].createElement("span", null, _this2.getTooltipBySentimentValue(region.value))
        }, /*#__PURE__*/_react["default"].createElement("rect", {
          key: region.start + "-" + region.end + "-" + i,
          x: region.start / mediaDuration * 100,
          y: "0",
          width: width,
          height: "10",
          fill: isSentimentAnalyzerOn ? getColorBySentimentValue(region.value) : color
        }));
      })))));
    }

    return null;
  };

  return RegionTrack;
}(_react["default"].Component);

_defineProperty(RegionTrack, "defaultProps", {
  height: 8,
  color: "black"
});

RegionTrack.propTypes = process.env.NODE_ENV !== "production" ? {
  height: _propTypes["default"].number,
  regions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    start: _propTypes["default"].number.isRequired,
    end: _propTypes["default"].number.isRequired,
    color: _propTypes["default"].string
  })).isRequired,
  duration: _propTypes["default"].number,
  color: _propTypes["default"].string,
  isSentimentAnalyzerOn: _propTypes["default"].bool
} : {};

var _default = (0, _connectToMedia["default"])(mapStateToProps)(RegionTrack);

exports["default"] = _default;